import { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";
import { toast } from "react-toastify";
import { cancelOrderApi, pharmacyDashboardAPI, pharmacyDashboardOrdersAPI, updateOrderStatusAPI, getOrdersDetailsAPI, updateOrder } from "../../api/pahrmacy";
import { Spinner, Card, CardBody, Badge, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from "reactstrap";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
} from "../../components/Component";
import RecentOrders from "../../components/partials/default/recent-orders/RecentOrders";
import StoreStatistics from "../../components/partials/default/StoreStatistics";
import Customer from "../../components/partials/e-commerce/customers/Customer";
import Orders from "../../components/partials/e-commerce/orders/Orders";
import TotalSales from "../../components/partials/e-commerce/total-sales/TotalSales";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import useLogout from "../../hooks/useLogout";
import CancelOrderModal from "../../MyComp/UI/modals/CancelOrderModal";
import { decrypt } from "../../utils/Utils";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import PharmacyOrder from "../../components/partials/default/recent-orders/PharmacyOder";
import moment from "moment";
import { BASE_URL_IMG, RUPEES_SYMBOL } from "../../assets/constants";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import { confirmOrderSplit, listPharmacyTelecaller } from "../../api/pahrmacy";
import { searchMedicine } from "../../api/pahrmacy";
import { MdPaid } from "react-icons/md";
import paidImg from "../../assets/images/jsTree/paid.png";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";



const PharmacyDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useLogout();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [pharmacyLoading, setPharmacyLoading] = useState(false);
  const [pharmacyData, setPharmacyData] = useState([]);
  const [hours, setHours] = useState("");
  const [minutes, setMinutes] = useState("");
  




  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: true,
      tableLoading: true,
      orderData: [],
      cardData: [],
      salesData: [],
      orders: [],
      customerData: [],
      storeStats: [],
      limit: 10,

      mode: location?.state?.mode || "Add",
      actionType: null,
    },
  });

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "delivered":
      case "paid":
        return "success";
      case "processing":
      case "shipped":
      case "out_for_delivery":
        return "warning";
      case "cancelled":
        return "danger";
      default:
        return "primary";
    }
  };
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [onSearch, setonSearch] = useState(false);
  const [onSearchText, setSearchText] = useState("");
  const [imageOpen, setImageOpen] = useState(false);
  // const isLoading = watch("isLoading");
  const tableLoading = watch("tableLoading");
  const orderData = watch("orderData");
  const salesData = watch("salesData");
  const storeStats = watch("storeStats");
  // const orders = watch("orders");
  const limit = watch("limit");
  const customerData = watch("customerData");
  const user = decrypt(localStorage.getItem("userDetail"))
  const [isOpen, setIsOpen] = useState(false)
  const [selectedRow1, setSelectedRow1] = useState([])
  const [isLoading, setIsLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [data, setData] = useState(null);
  const [selectedMedicines, setSelectedMedicines] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [medicineItems, setMedicineItems] = useState([]);
  const [viewModal, setViewModal] = useState(false);
  const [estimatedTime, setEstimatedTime] = useState("");
  const [remark, setRemark] = useState("");
  const [showInput, setShowInput] = useState(true);
  const [searchTexts, setSearchTexts] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [qty, setQty] = useState("");
  const [selectedMedicine, setSelectedMedicine] = useState(null);
  const [items, setItems] = useState([]);
  const [isChanged, setIsChanged] = useState(false);
  const [originalItems, setOriginalItems] = useState([]);


  const handleImageOpenPreview = (imageUrl) => {
    setValue("image_preview", imageUrl);
  };





  // const handleGoDashboard = (row) => {
  //   setSelectedRow(row);
  //   // Reset selections when opening modal for new pharmacy
  //   setSelectedMedicines([]);
  //   setSelectAll(false);
  //   setMedicineItems(medicineItems.map(item => ({ ...item, selected: false })));
  //   setViewModal(true);
  // };
  const handleGoDashboard = (row) => {
    setSelectedRow(row);

    // Select all medicines automatically
    const allItemIds = medicineItems.map(item => item.id);

    setSelectedMedicines(allItemIds);
    setSelectAll(true);

    setMedicineItems(
      medicineItems.map(item => ({
        ...item,
        selected: true
      }))
    );

    setViewModal(true);
  };
  const userId = localStorage.getItem("userId")

  //   useEffect(() => { })
  //   useEffect(() => {
  //     getDashboardData();
  //   }, []);
  const getDashboardData = () => {
    console.log(userId, location?.state, "userId")
    setValue("isLoading", true);
    pharmacyDashboardAPI(location?.state)
      .then((res) => {
        //const status = decrypt(res.data.status);

        if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          console.log(res?.data?.data?.orderData, "datataattres?.data?.data?.orderData)")
          setValue("salesData", res?.data?.data?.salesData);
          setValue("orders", res?.data?.data?.orderData);
          setValue("cardData", res?.data?.data?.cardData)
          setValue("customerData", res?.data?.data?.customerData);
          setValue("storeStats", res?.data?.data?.storeStats);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("cityDD", []);
          // toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          // toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        // toast.error(err?.response?.data?.message);
      });
  };
  // const handleSelectAll = () => {
  //   setSelectAll(!selectAll);
  //   if (!selectAll) {
  //     const allItemIds = medicineItems.map(item => item.id);
  //     setSelectedMedicines(allItemIds);
  //     setMedicineItems(medicineItems.map(item => ({ ...item, selected: true })));
  //   } else {
  //     setSelectedMedicines([]);
  //     setMedicineItems(medicineItems.map(item => ({ ...item, selected: false })));
  //   }
  // };
  const handleSelectAll = () => {
    const newValue = !selectAll;
    setSelectAll(newValue);

    const updatedItems = medicineItems.map(item => ({
      ...item,
      selected: newValue,
    }));

    setMedicineItems(updatedItems);

    if (newValue) {
      setSelectedMedicines(updatedItems.map(item => item.id));
    } else {
      setSelectedMedicines([]);
    }
  };


  const cardData = watch("cardData");
  const getOrders = (body) => {
    pharmacyDashboardOrdersAPI(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("limit", res.data.data?.totalPages);
          setValue("orderData", res.data.data);

          setValue("tableLoading", false);
        } else if (res.data.status === false) {
          setValue("tableLoading", false);
          setValue("cityDD", []);
          // toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("tableLoading", false);
          // toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("tableLoading", false);
        // toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(onSearchText);
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler);
    };
  }, [onSearchText]);

  useEffect(() => {
    const body = {
      search: debouncedSearch,
      page: currentPage,
      limit: itemPerPage,
      pharmacyId: location?.state?.pharmacyId,
    };

    getOrders(body);
  }, [debouncedSearch, currentPage, itemPerPage]);

  const onOrderClick = (item) => {
    const body = {
      orderId: item?.id,
      userId: item?.userId,
    };
    navigate("/order-details", { state: body });
  };
  const onViewClick = (item) => {

    const body = {
      orderId: item?.id,
      userId: item?.userId,
    };
    setIsLoading(true);
    getOrdersDetailsAPI(body)
      .then((res) => {
        if (res?.data?.status === "expired") {
          toast.error(res?.data?.message);
          logout();
          return;
        }
        if (res?.data?.status === true) {
          const { order, orderItems } = res?.data?.data;
          const ph = order?.pharmacy;
          setOrders(order);

          // setMedicineItems(orderItems)
          const itemsWithSelection = orderItems.map(item => ({
            ...item,
            selected: true
          }));

          setMedicineItems(itemsWithSelection);
          setSelectedMedicines(itemsWithSelection.map(item => item.id));
          setSelectAll(true);
          setItems([]);

          setData({
            id: order?.id,
            pharmacy_name: ph?.store_name,
            pharmacy_gst: ph?.gst_number,
            pharmacy_contact: ph?.mobile,
            order_no: order?.orderNum,
            date: order?.createdAt ? moment(order.createdAt).format("DD MMM YYYY, hh:mm A") : "",
            order_status: order?.status,
            subtotal: order?.orderAmount || 0,
            tax: 0,
            discount: order?.discountAmount || 0,
            promotionAmount: order?.promotionAmount || 0,
            shipping_cost: 0,
            total_amount: order?.totalAmount || 0,
            paidAmount: order?.unpaidOrder?.paidAmount || 0,
            dueAmount: order?.unpaidOrder?.dueAmount || 0,
            refundAmount: order?.unpaidOrder?.refundAmount || 0,
            remark: order?.remark || "",
            payment: order?.payment?.payment_method || "",
            totalTax: order?.totalTax || 0,
            address: {
              full_name: order?.address?.name || "",
              mobile: order?.address?.mobile || "",
              address: order?.address?.addressLine1 || "",
              city: order?.address?.city || "",
              state: order?.address?.state || "",
              country: "India",
              postal_code: order?.address?.postalCode || "",
            },
            items:
              orderItems?.map((item) => ({
                medicineId: item?.medicineId,
                product_name: item?.medicineName || "",
                unit_price: item?.price || 0,
                quantity: item?.quantity || 0,
                total: ((item?.price || 0) * (item?.quantity || 0)).toFixed(2),
              })) || [],
          });

          listPharmacyTelecaller({ orderId: order?.id })
            .then((res) => {
              if (res?.data?.status === "expired") {
                toast.error(res?.data?.message);
                logout();
              }
              else if (res?.data?.status === true) {


                setPharmacyData(res?.data?.data?.nearbyPharmacies || []);
              }
              else {
                setPharmacyData([]);
              }
            })
            .catch((err) => {
              console.log(err);
              setPharmacyData([]);
            });
        }
      })
      .catch((err) => {
        console.error("Order details error", err);
        toast.error("Something went wrong");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  //       } else {
  //         toast.error(res?.data?.message || "Failed to load order");
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Order details error", err);
  //       toast.error("Something went wrong");
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //     });
  // };
  const [showModal, setShowModal] = useState(false);

  const [selectedRow, setSelectedRow] = useState(false);

  const toggleCancelOrder = (item) => {
    setShowModal(true);
    setSelectedRow(item);

    console.log(item, "item");
  };



  const handleMedicineSelect = (itemId) => {
    let updatedSelected = [...selectedMedicines];
    let updatedItems = medicineItems.map(item => {
      if (item.id === itemId) {
        const newSelected = !item.selected;
        if (newSelected) {
          updatedSelected.push(item.id);
        } else {
          updatedSelected = updatedSelected.filter(id => id !== item.id);
        }
        return { ...item, selected: newSelected };
      }
      return item;
    });

    setSelectedMedicines(updatedSelected);
    setMedicineItems(updatedItems);
    setSelectAll(updatedSelected.length === medicineItems.length);
  };

  const handleConfirmClick = async () => {
    if (selectedMedicines.length === 0) {
      toast.warning("Please select at least one medicine to confirm");
      return;
    }

    try {
      // Get selected medicines
      const selectedItems = medicineItems.filter(item =>
        selectedMedicines.includes(item.id)
      );

      // Create allocations object
      const allocation = {
        [selectedRow?.pharmacyId]: selectedItems.map(item => ({
          medicineId: item.medicineId
        }))
      };


      // Final payload
      const payload = {
        orderId: data?.id,
        estimatedTime: `${hours || 0}hr ${minutes || 0}min`,
        remark: remark,
        allocation
      };
      console.log(payload, "payload");

      // API Call
      const response = await confirmOrderSplit(payload);

      if (response?.data?.message) {
        toast.success(response.data.message);
      } else {
        toast.success("Order confirmed successfully!");
      }

      //  Close modal + clear all related state
      setViewModal(false);
      setData(null);              // ← clears the right panel
      setMedicineItems([]);
      setSelectedMedicines([]);
      setSelectAll(false);
      setEstimatedTime("");
      setRemark("");

      //  Refresh the orders list (remove the bare pharmacyDashboardOrdersAPI() call)
      const body = {
        search: debouncedSearch,
        page: currentPage,
        limit: itemPerPage,
        pharmacyId: location?.state?.pharmacyId,
      };
      getOrders(body);



    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else if (error.message) {
        toast.error(error.message);
      } else {
        toast.error("Failed to confirm order. Please try again.");
      }

      console.error("Error confirming order:", error);
    }
  };

  const handleCancelOrder = (reason) => {
    if (!selectedRow) return;
    console.log(selectedRow, "selectedRow");

    const payload = {
      orderId: selectedRow?.id,
      remark: reason,
      mobile: selectedRow?.address?.mobile,
    };

    console.log("Confirmed cancel order:", payload);

    cancelOrderApi(payload)
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          //  Close modal + clear all related state
          setShowModal(false);
          setData(null);
          setMedicineItems([]);
          setSelectedMedicines([]);
          setSelectAll(false);
          setEstimatedTime("");
          setRemark("");
          setSelectedRow(null);

          // ✅ Refresh orders list
          const body = {
            search: debouncedSearch,
            page: currentPage,
            limit: itemPerPage,
            pharmacyId: location?.state?.pharmacyId,
          };
          getOrders(body);

        } else if (res.data.status === false) {
          // toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  const renderSparkline = (values, color) => {
    const max = Math.max(...values);
    const min = Math.min(...values);

    const points = values
      .map((v, i) => {
        const x = (i / (values.length - 1)) * 100;
        const y = 30 - ((v - min) / (max - min || 1)) * 30;
        return `${x},${y}`;
      })
      .join(" ");

    return (
      <svg width="90" height="30" viewBox="0 0 100 30">
        <polyline
          fill="none"
          stroke={`var(--bs-${color})`}
          strokeWidth="2"
          points={points}
        />
      </svg>
    );
  };



  const KPICardSkeleton = () => (
    <div className="col-xl-3 col-md-6">
      <div className="card shadow-sm h-100 p-3">
        <div className="card-body d-flex justify-content-between align-items-center">
          {/* Left content */}
          <div>
            {/* Title */}
            <Skeleton height={12} width={90} className="mb-2" />

            {/* Value row */}
            <div className="d-flex align-items-center gap-2 mb-2">
              <Skeleton height={15} width={110} />
              <Skeleton height={15} width={80} />
            </div>

            {/* Trend text */}
            <Skeleton height={12} width={130} />
          </div>
        </div>
      </div>
    </div>
  );
  const MiddleCardSkeleton = ({ height = 220 }) => (
    <div className="card shadow-sm h-100 p-4">
      <Skeleton width={120} height={10} className="mb-3" />
      <Skeleton width={180} height={40} className="mb-3" />
      <Skeleton width={180} height={10} className="mb-3" />

      <Skeleton width={180} height={15} className="mb-3" />

      <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
        <Skeleton width={180} height={15} className="mb-3" />
        <Skeleton width={40} height={10} className="mb-3" />
      </div>
      <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
        <Skeleton width={180} height={40} className="mb-3" />
        <Skeleton width={80} height={15} className="mb-" />
      </div>

      <div className="mt-5">
        <Skeleton width="100%" height={30} borderRadius={6} />
      </div>
    </div>
  );

  const MiddleCardStatic = ({ height = 120 }) => {
    return (
      <div className="card card-bordered h-100">
        <div className="card-inner">
          {/* Title */}
          <Skeleton width={120} height={18} />

          <div className="mt-3">
            {[1, 2, 3, 4].map((_, idx) => (
              <div key={idx} className="d-flex justify-content-between align-items-center mb-3">
                {/* Left text */}
                <div>
                  <Skeleton width={100} height={14} />
                  <Skeleton width={30} height={18} className="mt-1" />
                </div>

                {/* Right icon box */}
                <Skeleton width={40} height={40} borderRadius={8} />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const MiddleCardOrder = ({ height = 100 }) => {
    return (
      <div className="card card-bordered h-100">
        <div className="card-inner">
          {/* Top row */}
          <div className="mt-2">
            <Skeleton width={80} height={18} />


          </div>

          {/* Main number */}
          <div className="d-flex justify-content-between align-items-start">
            <Skeleton width={60} height={36} />
            <div className="text-end">
              <Skeleton width={40} height={14} />
              <Skeleton width={80} height={14} className="mt-1" />
            </div>
          </div>

          {/* Chart placeholder */}
          <div className="mt-3">
            <Skeleton width="100%" height={30} borderRadius={6} />
          </div>
        </div>
      </div>
    );
  };

  const RecentOrdersSkeleton = ({ rows = 6 }) => {
    return (
      <div className="card card-bordered">
        {/* Header */}
        <div className="card-inner d-flex justify-content-between align-items-center">
          <Skeleton width={150} height={22} />
          <div className="d-flex gap-3">
            <Skeleton width={24} height={24} circle />
            <Skeleton width={24} height={24} circle />
          </div>
        </div>

        {/* Table */}
        <div className="nk-tb-list is-separate">
          {/* Table Head */}
          <div className="nk-tb-item nk-tb-head">
            {Array.from({ length: 8 }).map((_, i) => (
              <div className="nk-tb-col" key={i}>
                <Skeleton width={80} height={14} />
              </div>
            ))}
          </div>

          {/* Rows */}
          {Array.from({ length: rows }).map((_, idx) => (
            <div className="nk-tb-item" key={idx}>
              {/* Order No */}
              <div className="nk-tb-col">
                <Skeleton width={90} height={14} />
              </div>

              {/* Customer */}
              <div className="nk-tb-col">
                <div className="d-flex align-items-center gap-2">
                  <Skeleton width={36} height={36} circle />
                  <Skeleton width={120} height={14} />
                </div>
              </div>

              {/* Date */}
              <div className="nk-tb-col">
                <Skeleton width={90} height={14} />
              </div>

              {/* Amount */}
              <div className="nk-tb-col">
                <Skeleton width={60} height={14} />
              </div>

              {/* Address */}
              <div className="nk-tb-col">
                <Skeleton width={180} height={14} />
              </div>

              {/* Purchased */}
              <div className="nk-tb-col">
                <Skeleton width={70} height={14} />
              </div>

              {/* Pharmacy */}
              <div className="nk-tb-col">
                <Skeleton width={90} height={14} />
              </div>

              {/* Status */}
              <div className="nk-tb-col">
                <Skeleton width={70} height={14} />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  const updateOrderStatus = (item) => {
    console.log("order", item)
    const payload = {
      orderId: item?.id,
      status: item?.next_status
    }

    updateOrderStatusAPI(payload)
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          setIsOpen(false);
          const body = {
            search: debouncedSearch,
            page: currentPage,
            limit: itemPerPage,
            pharmacyId: location?.state?.pharmacyId,
          };

          getOrders(body);
        } else if (res.data.status === false) {
          // toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          // toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        // toast.error(err?.response?.data?.message);
      });
  }




  const handleSearch = (value) => {
    console.log("[TelecallerPharmacy] Search input:", value);
    setSearchTexts(value);

    if (selectedMedicine && value !== selectedMedicine.name) {
      setSelectedMedicine(null);
      setQty("");
    }

    if (!value || value.length < 2) {
      setSearchResults([]); //  reset
      return;
    }

    searchMedicine({
      search: value,
      page: 1,
      limit: 10,
    })


      .then((res) => {
        if (res?.data?.status) {
          setSearchResults(res?.data?.data || []);
        } else {
          setSearchResults([]); //  fallback
        }
        console.log(res, "search results");

      })
      .catch((err) => {
        console.log(err);
        setSearchResults([]); //  fallback
      });
  };

  // const handleSelectMedicine = (medicine) => {
  //   setTableData((prev) => {
  //     const alreadyExists = prev.find((item) => item.id === medicine.id);

  //     if (alreadyExists) {
  //       return prev.map((item) =>
  //         item.id === medicine.id
  //           ? { ...item, quantity: (item.quantity || 0) + 1 }
  //           : item
  //       );
  //     }

  //     return [
  //       ...prev,
  //       {
  //         ...medicine,
  //         quantity: 1,
  //         isChecked: true,
  //       },
  //     ];
  //   });

  //   //  FIX HERE → use correct state
  //   setSearchTexts(medicine.name);  //  SHOW selected medicine in input

  //   //  Hide dropdown
  //   setSearchResults([]);
  // };


  const handleSelectMedicine = (medicine) => {
    console.log("[TelecallerPharmacy] Selected medicine:", medicine);
    setSelectedMedicine(medicine); // store selected
    setSearchTexts(medicine.name); // show selected medicine name in input
    setQty(""); // reset qty once new medicine is selected
    setSearchResults([]); // hide dropdown
  };

  const handleIncreaseQty = (medicineId) => {
    setData((prev) => {
      const updatedItems = prev.items.map((item) => {
        if (item.medicineId === medicineId) {
          const newQty = item.quantity + 1;

          return {
            ...item,
            quantity: newQty,
            total: (newQty * item.unit_price).toFixed(2),
          };
        }
        return item;
      });
      checkIfChanged(updatedItems);

      return { ...prev, items: updatedItems };
    });

    // 🔥 sync items payload
    setItems((prev) =>
      prev.map((item) =>
        item.productId === medicineId
          ? { ...item, quantity: item.quantity + 1 }
          : item
      )
    );
  };
  const handleDecreaseQty = (medicineId) => {
    setData((prev) => {
      const updatedItems = prev.items.map((item) => {
        if (item.medicineId === medicineId && item.quantity > 1) {
          const newQty = item.quantity - 1;

          return {
            ...item,
            quantity: newQty,
            total: (newQty * item.unit_price).toFixed(2),
          };
        }
        return item;
      });
      checkIfChanged(updatedItems);

      return { ...prev, items: updatedItems };
    });

    setItems((prev) =>
      prev.map((item) =>
        item.productId === medicineId && item.quantity > 1
          ? { ...item, quantity: item.quantity - 1 }
          : item
      )
    );
  };

  console.log("items before delete", items);

  const handleDeleteItem = (index) => {
    setData((prev) => {
      const updatedItems = prev.items.map((item, i) =>
        i === index ? { ...item, quantity: 0, total: "0.00" } : item
      );
      checkIfChanged(updatedItems);
      return { ...prev, items: updatedItems };
    });
  };

  const handleAddMedicine = () => {
    console.log("[TelecallerPharmacy] Add medicine clicked", { selectedMedicine, qty, items });
    if (!selectedMedicine) {
      toast.warning("Please select a medicine before adding.");
      return;
    }

    const quantity = Number(qty);
    if (!quantity || quantity <= 0) {
      toast.warning("Please enter a valid quantity.");
      return;
    }

    const newItem = {
      productId: selectedMedicine.id,
      medicineId: selectedMedicine.id,
      product_name: selectedMedicine.name,
      name: selectedMedicine.name,
      unit_price: selectedMedicine.original_price || 0,
      quantity: quantity,
      total: ((selectedMedicine.original_price || 0) * quantity).toFixed(2),
    };

    setItems((prev) => [...prev, newItem]);

    setIsChanged(true);

    // reset for next entry
    setSearchTexts("");
    setQty("");
    setSelectedMedicine(null);
    setSearchResults([]);
  };

  // console.log("Selected Medicines:", selectedMedicines);
  // console.log("items", items);

  const getMergedItems = () => {
    const existingItems = data?.items || [];
    if (!items?.length) return existingItems.map(({ productId, ...item }) => ({
      ...item,
      medicineId: item.medicineId || productId,
    }));

    const map = new Map();

    existingItems.forEach((item) => {
      const medicineId = item.medicineId || item.productId;
      if (!medicineId) return;
      map.set(medicineId, {
        ...item,
        medicineId,
      });
    });

    items.forEach((item) => {
      const medicineId = item.medicineId || item.productId;
      if (!medicineId) return;
      if (map.has(medicineId)) {
        const prev = map.get(medicineId);
        const newQty = Number(prev.quantity || 0) + Number(item.quantity || 0);
        const unitPrice = Number(prev.unit_price || prev.price || 0);
        map.set(medicineId, {
          ...prev,
          quantity: newQty,
          total: (newQty * unitPrice).toFixed(2),
          medicineId,
        });
      } else {
        map.set(medicineId, {
          ...item,
          medicineId,
          total:
            item.total ??
            ((Number(item.unit_price || item.price || 0) * Number(item.quantity || 0)).toFixed(2)),
        });
      }
    });

    return Array.from(map.values())
      .map(({ productId, ...item }) => item);
  };

  const payload = {
    orderId: data?.id,
    items: getMergedItems(),
  };

  console.log("Payload for updateOrder:", payload);

  const handleSubmitOrder = () => {

    if (payload.items.length === 0) {
      toast.warning("Please select at least one medicine");
      return;
    }


    updateOrder(payload)
      .then((res) => {
        if (res?.data?.status === true) {
          toast.success("Order updated successfully");

          // ✅ REFETCH ORDER DETAILS (IMPORTANT)
          onViewClick({
            id: data?.id,
            userId: orders?.userId,
          });

          // ✅ RESET INPUT STATE
          setItems([]);
          setSearchTexts("");
          setSelectedMedicine(null);
          setQty("");

        } else {
          toast.error(res?.data?.message || "Failed");
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong");
      });
  };

  useEffect(() => {
    if (data?.items) {
      setOriginalItems(JSON.parse(JSON.stringify(data.items)));
    }
  }, [data]);

  const checkIfChanged = (updatedItems) => {
    const changed = updatedItems.some((item) => {
      const original = originalItems.find(
        (o) => o.medicineId === item.medicineId
      );
      return original?.quantity !== item.quantity;
    });

    setIsChanged(changed);
  };

//   useEffect(() => {
//   const body = { search: debouncedSearch, page: currentPage, limit: itemPerPage, pharmacyId: location?.state?.pharmacyId };
//   getOrders(body);
// }, [debouncedSearch, currentPage, itemPerPage]);

  return (
    <>
      <Head title={"order Dashboard"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Pharmacy Order"}
              </BlockTitle>
            </BlockHeadContent>
            {user?.role == "admin" && <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    navigate("/pharmacy-list");
                  }}
                >
                  <Icon name={"arrow-left"} />
                </Button>
              </div>
            </BlockHeadContent>}
          </BlockBetween>
        </BlockHead>
        <Block>

          <div className=" my-3">

          </div>

          <Row className="g-gs">
            <Col xxl="4" lg="4" md="4">
              <div className="card card-bordered">
                <div className="card-inner-group">
                  <div className="card-inner">
                    <div className="card-title-group">
                      <div className="card-title">
                        <h6 className="title"> New Orders</h6>
                      </div>
                    </div>
                  </div>

                  {tableLoading ? (
                    <div className="card-inner">
                      <Skeleton height={40} className="mb-2" />
                      <Skeleton height={40} className="mb-2" />
                      <Skeleton height={40} />
                    </div>
                  ) : (
                    orderData?.orders
                      ?.filter((item) => item?.status === "pending")
                      ?.slice(0, 10).map((item, index) => (
                        <div className="card-inner card-inner-md" key={index}>
                          <div className="">
                            <div className="user-info d-flex justify-content-between">

                              <div>
                                <a href="#" onClick={() => onViewClick(item)}>
                                  <span className="lead-text text-primary">
                                    {item?.orderNum}

                                  </span>
                                </a>

                                <span className="sub-text">
                                  {new Date(item?.date).toLocaleString()}
                                </span>


                                <span
                                  className={`badge-dot badge-dot-xs text-capitalize badge
                    ${item?.status === "pending"
                                      ? "bg-danger"
                                      : item?.status === "completed"
                                        ? "bg-success"
                                        : "bg-warning"
                                    }`}
                                >
                                  {item?.status}
                                </span>

                              </div>
                              <div>
                                <span className="lead-text text-info">
                                  {item?.user?.name}

                                </span>
                                <span className="lead-text badge-warning">
                                  {item?.user?.mobile}

                                </span>
                              </div>



                            </div>

                            {/* <div className="user-action">
                              <button
                                className="btn btn-icon btn-trigger me-n1"
                                onClick={() => onViewClick(item)}
                              >
                                <Icon name="arrow-right" />
                              </button>
                            </div> */}
                          </div>
                        </div>
                      ))
                  )}
                  {!tableLoading && limit > 1 && (
                    <div className="card-inner">
                      <Pagination className="justify-content-center mt-2">
                        <PaginationItem disabled={currentPage === 1}>
                          <PaginationLink
                            previous
                            onClick={() => paginate(currentPage - 1)}
                          />
                        </PaginationItem>

                        {Array.from({ length: limit }, (_, i) => i + 1).map((page) => (
                          <PaginationItem active={page === currentPage} key={page}>
                            <PaginationLink onClick={() => paginate(page)}>
                              {page}
                            </PaginationLink>
                          </PaginationItem>
                        ))}

                        <PaginationItem disabled={currentPage === limit}>
                          <PaginationLink
                            next
                            onClick={() => paginate(currentPage + 1)}
                          />
                        </PaginationItem>
                      </Pagination>
                    </div>
                  )}

                </div>
              </div>
            </Col>
            {data &&
              <>
                <Col xxl="8" lg="8" md="8">
                  <Card className="card-bordered">
                    <CardBody>
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0">Order Items</h5>
                        <Badge color={getStatusColor(data?.order_status)} pill>
                          {data?.order_status}
                        </Badge>
                      </div>

                      <div className="mb-3 pb-2 border-bottom">
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Order :</span>
                          <span className="fw-bold">{data?.order_no}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Date:</span>
                          <span>{data?.date}</span>
                        </div>
                        {/* <div className="d-flex justify-content-between">
                          <span className="fw-bold">Payment Method:</span>
                          <span className="fw-bold">{data?.payment}</span>
                        </div> */}
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="fw-bold">Payment Method:</span>

                          <span className="fw-bold d-flex align-items-center">
                            {data?.payment}

                            {data?.payment?.toLowerCase() === "online" && (
                              <img
                                src={paidImg}
                                alt="paid"
                                style={{ width: "40px", marginLeft: "8px" }}
                              />
                            )}
                          </span>
                        </div>
                      </div>

                      {/* Items List */}
                      <div className="mb-4" style={{ maxHeight: "250px", overflowY: "auto" }}>
                        <table className="table table-sm">
                          <thead className="table-light">
                            <tr>
                              <th style={{ width: "350px" }}>Item</th>
                              <th className="text-center" style={{ width: "170px" }}>Qty</th>
                              <th className="text-end" style={{ width: "250px" }}>Price</th>
                              <th className="text-end" style={{ width: "250px" }}>Total</th>
                              <th className="text-center" style={{ width: "250px" }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.items
                              .filter((item) => Number(item.quantity || 0) > 0)
                              .map((item, idx) => (
                                <tr key={idx}>
                                  <td>
                                    <div className="fw-medium">{item.product_name}</div>
                                  </td>

                                  {/* Qty with + - */}
                                  <td className="text-center ps-5">
                                    {/* <div className="d-flex align-items-center justify-content-center">
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-outline-danger mx-1"
                                        onClick={() => handleDecreaseQty(item.medicineId)}
                                      >
                                        -
                                      </button>

                                      <span className="mx-1" style={{ width: "20px" }}>{item.quantity}</span>

                                      <button
                                        type="button"
                                        className="btn btn-sm btn-outline-success mx-1"
                                        onClick={() => handleIncreaseQty(item.medicineId)}
                                      >
                                        +
                                      </button>
                                    </div> */}
                                    <div
                                      className="d-flex align-items-center justify-content-between px-2"
                                      style={{
                                        border: "1px solid #ccc",
                                        borderRadius: "50px", // 🔥 makes it oval
                                        width: "100px",
                                        height: "35px",
                                        background: "#f9f9f9",
                                      }}
                                    >
                                      {/* ➖ Decrease */}
                                      <button
                                        type="button"
                                        onClick={() => handleDecreaseQty(item.medicineId)}
                                        style={{
                                          border: "none",
                                          background: "transparent",
                                          fontSize: "18px",
                                          cursor: "pointer",
                                          color: "#dc3545",
                                        }}
                                      >
                                        −
                                      </button>

                                      {/* 🔢 Quantity */}
                                      <span style={{ fontWeight: "500", fontSize: "14px" }}>
                                        {item.quantity}
                                      </span>

                                      {/* ➕ Increase */}
                                      <button
                                        type="button"
                                        onClick={() => handleIncreaseQty(item.medicineId)}
                                        style={{
                                          border: "none",
                                          background: "transparent",
                                          fontSize: "18px",
                                          cursor: "pointer",
                                          color: "#28a745",
                                        }}
                                      >
                                        +
                                      </button>
                                    </div>
                                  </td>

                                  <td className="text-end">
                                    {RUPEES_SYMBOL}
                                    {item.unit_price}
                                  </td>

                                  <td className="text-end">
                                    {RUPEES_SYMBOL}
                                    {item.total}
                                  </td>

                                  {/* 🗑 Delete Button */}
                                  <td className="text-center">
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-danger"
                                      onClick={() => handleDeleteItem(idx)}
                                    >
                                      🗑
                                    </button>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="d-flex gap-2 pb-5">
                        <div>
                          {showInput && (
                            <div style={{ width: "100%", position: "relative" }}>

                              {/* 🔍 Input Field */}
                              <input
                                type="text"
                                placeholder="Search medicine..."
                                value={searchTexts}
                                onChange={(e) => handleSearch(e.target.value)}
                                style={{
                                  width: "100%",
                                  padding: "6px",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                }}
                              />

                              {/* 📦 Dropdown */}
                              {searchResults?.length > 0 && (
                                <div style={{
                                  position: "absolute",
                                  top: "38px",
                                  width: "100%",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                  maxHeight: "150px",
                                  overflowY: "auto",
                                  background: "#fff",
                                  zIndex: 1000,
                                }}>
                                  {searchResults.map((item) => (
                                    <div
                                      key={item.id}
                                      style={{
                                        padding: "6px",
                                        cursor: "pointer",
                                        borderBottom: "1px solid #eee",
                                      }}
                                      onClick={() => handleSelectMedicine(item)}
                                    >
                                      {item.name}
                                    </div>
                                  ))}
                                </div>
                              )}




                            </div>

                          )}
                        </div>
                        <div>
                          {/* ✅ Qty Input (NEW) */}
                          {selectedMedicine && (
                            <input
                              type="number"
                              min="1"
                              placeholder="Enter quantity"
                              value={qty}
                              onChange={(e) => {
                                const value = e.target.value;
                                console.log("[TelecallerPharmacy] Qty changed:", value);
                                setQty(value);
                              }}
                              style={{
                                width: "100%",
                                padding: "6px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                              }}
                            />
                          )}
                        </div>
                        <div>
                          <Button
                            color="primary"
                            onClick={handleAddMedicine}
                            disabled={!selectedMedicine || !qty}
                          >
                            Add Medicine
                          </Button>

                        </div>
                        <div>
                          <Button
                            className={"bg-primary text-light"}
                            onClick={() => handleSubmitOrder()}
                            disabled={!isChanged} // ✅ ADD THIS

                          // onClick={() => toggleCancelOrder(data)}
                          >
                            Update Order
                          </Button>
                        </div>
                      </div>

                      <div style={{ width: "300px" }}>
                        {/* 🧾 Selected Items List */}
                        {items.length > 0 && (
                          <div style={{ marginTop: "12px", border: "1px solid #eee", borderRadius: "4px", padding: "8px" }}>
                            <strong>Added Medicines:</strong>
                            {items.map((item, idx) => (
                              <div
                                key={`${item.id}-${idx}`}
                                className="d-flex justify-content-between align-items-center mt-2"
                              >
                                <div>
                                  <div>{item.name || "Unnamed medicine"}</div>
                                  <small className="text-muted">
                                    Price: {RUPEES_SYMBOL}{item.unit_price}
                                  </small>
                                </div>

                                <div className="text-end">
                                  <div>Qty: {item.quantity}</div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>


                      {/* Order Summary */}
                      <div className="bg-light p-3 rounded mb-3 mt-4">
                        <div className="d-flex justify-content-between mb-1">
                          <span>Subtotal:</span>
                          <span>
                            {RUPEES_SYMBOL}
                            {Number(data?.subtotal || 0).toFixed(2)}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                          <span>Discount:</span>
                          <span className="text-primary">
                            - {RUPEES_SYMBOL}
                            {data.discount}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                          <span>Coupon Discount:</span>
                          <span className="text-primary">
                            - {RUPEES_SYMBOL}
                            {data.promotionAmount}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                          <span>Total Tax:</span>
                          <span className="text-primary">
                            {RUPEES_SYMBOL}
                            {data.totalTax}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between fw-bold pt-2 border-top">
                          <span>Grand Total(Included of all taxes):</span>
                          <span className="text-primary">
                            {RUPEES_SYMBOL}
                            {data.total_amount}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between fw-bold pt-2 border-top">
                          <span>Paid Amount:</span>
                          <span className="text-primary">
                            {RUPEES_SYMBOL}
                            {data.paidAmount}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between fw-bold pt-2 border-top">
                          <span>Due Amount:</span>
                          <span className="text-primary">
                            {RUPEES_SYMBOL}
                            {data.dueAmount}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between fw-bold pt-2 border-top">
                          <span>Refund Amount:</span>
                          <span className="text-primary">
                            {RUPEES_SYMBOL}
                            {data.refundAmount}
                          </span>
                        </div>
                      </div>

                      {/* Customer Info */}
                      <div className="rounded">
                        <h6 className="mb-2">Customer Details</h6>
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <Icon name="user" size={16} />
                          <span>{data.address.full_name}</span>
                        </div>
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <Icon name="call" size={16} />
                          <span>{data.address.mobile}</span>
                        </div>
                        <div className="d-flex align-items-start gap-2">
                          <Icon name="map-pin" size={16} className="mt-1" />
                          <span>
                            {data.address.address}, {data.address.city},
                            {data.address.state} - {data.address.postal_code}
                          </span>
                        </div>
                      </div>
                      {/* <div className="d-flex justify-content-between align-items-center mb-3 mt-5"> */}
                      {/* <h5 className="mb-0">Order Items</h5> */}

                      <Button
                        className={"bg-primary text-light mb-3 mt-5"}
                        onClick={() => toggleCancelOrder(data)}
                      >
                        Cancel Order
                      </Button>
                      {/* <Button
                        className={"bg-primary text-light mb-3 mt-4 ms-3"}
                        onClick={() => handleSubmitOrder()}
                      // onClick={() => toggleCancelOrder(data)}
                      >
                        Update Order
                      </Button> */}

                      {/* </div> */}
                    </CardBody>
                  </Card>

                  <Card className="card-bordered">
                    <CardBody>
                      <h5 className="mb-3">Nearby Pharmacies</h5>

                      {pharmacyLoading ? (
                        <div className="text-center py-4">
                          <Spinner color="primary" size="sm" />
                        </div>
                      ) : pharmacyData.length === 0 ? (
                        <div className="text-center py-4 text-muted">No pharmacies found</div>
                      ) : (
                        <div className="table-responsive">
                          <table className="table table-hover align-middle">
                            <thead className="table-light p-5">
                              <tr>
                                <th>Store</th>
                                <th>Contact</th>
                                <th>Distance</th>
                                {/* <th>Pincode</th> */}
                                <th className="text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {pharmacyData.map((row, index) => (
                                <tr key={index}>
                                  <td>
                                    <div className="d-flex align-items-center gap-2 py-4">
                                      <div className="avatar avatar-sm rounded-circle ">
                                        <UserAvatarCell
                                          row={row}
                                          name={row?.store_name}
                                          handleImageOpenPreview={handleImageOpenPreview}
                                          image={`${BASE_URL_IMG}${row.store_image}`}
                                        />
                                      </div>
                                      <div>
                                        <div className="fw-semibold">{row?.store_name}</div>
                                        <small className="text-muted">{row?.email}</small>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div>{row?.mobile || row?.contact_number}</div>
                                  </td>
                                  <td>
                                    <Badge color="light">{row?.distance} Km</Badge>
                                  </td>
                                  {/* <td>{row?.pincode}</td> */}
                                  <td className="text-center">
                                    <Button
                                      color="primary"
                                      size="xs"
                                      onClick={() => handleGoDashboard(row)}
                                      className="btn-icon p-1"
                                    >
                                      Assign
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>

                          {/* Pagination */}
                          {pharmacyData.length > 5 && (
                            <div className="d-flex justify-content-end mt-3">
                              <nav>
                                <ul className="pagination pagination-sm">
                                  <li className="page-item disabled">
                                    <span className="page-link">Previous</span>
                                  </li>
                                  <li className="page-item active">
                                    <span className="page-link">1</span>
                                  </li>
                                  <li className="page-item">
                                    <span className="page-link">2</span>
                                  </li>
                                  <li className="page-item">
                                    <span className="page-link">3</span>
                                  </li>
                                  <li className="page-item">
                                    <span className="page-link">Next</span>
                                  </li>
                                </ul>
                              </nav>
                            </div>
                          )}
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Col>
                <Head title="Order Details & Pharmacies" />
                <Content>
                  {/* Header Section */}
                  <BlockHead size="sm">
                    <BlockBetween>
                      <BlockHeadContent>{/* Empty for now */}</BlockHeadContent>
                      <BlockHeadContent>
                        <div className="d-flex gap-2">
                          {/* {data?.order_status === "processing" && (
                  <Button color="danger" outline onClick={() => toggleCancelOrder(data)}>
                    <Icon name="cross" />
                    <span className="ms-1">Cancel Order</span>
                  </Button>
                )} */}
                          {/* <Button className={"p-3"} color="primary" outline onClick={() => navigate(-1)}>
                            <Icon name="arrow-left" />
                           
                          </Button> */}
                        </div>
                      </BlockHeadContent>
                    </BlockBetween>
                  </BlockHead>

                  {/* Two Column Layout */}
                  <Row className="g-gs">
                    {/* Left Column - Order Details */}


                    {/* Right Column - Pharmacies */}
                    <Col lg="7">

                    </Col>
                  </Row>

                  {/* Updated Modal with Medicine Selection */}
                  <Modal isOpen={viewModal} toggle={() => setViewModal(false)} size="lg" centered>
                    <ModalHeader toggle={() => setViewModal(false)}>
                      Assign Order to {selectedRow?.store_name || "Pharmacy"}
                    </ModalHeader>

                    <ModalBody>
                      <div className="mb-4">
                        <h6 className="mb-3">Select Medicines to Assign:</h6>

                        {/* Select All Option */}
                        <FormGroup check className="mb-3 pb-2 border-bottom">
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={selectAll}
                              disabled={selectAll}
                              onChange={handleSelectAll}
                            />{' '}
                            <strong>Select All Medicines</strong>
                          </Label>
                        </FormGroup>

                        {/* Medicine List with Checkboxes */}
                        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                          {medicineItems.map((item) => (
                            <FormGroup check key={item.id} className="mb-2">
                              <Label check className="d-flex align-items-center">
                                <Input
                                  type="checkbox"
                                  checked={selectAll || item.selected}
                                  disabled={selectAll}   // 🔥 KEY LINE
                                  onChange={() => handleMedicineSelect(item.id)}
                                /> {' '}
                                <div className="ms-2">
                                  <div className="fw-medium">{item.medicineName}</div>
                                  <small className="text-muted">
                                    Qty: {item.quantity} | Price: {RUPEES_SYMBOL}{item.price} | Total: {RUPEES_SYMBOL}{item.total}
                                  </small>
                                </div>
                              </Label>
                            </FormGroup>
                          ))}
                        </div>

                        {/* Selected Summary */}
                        {selectedMedicines.length > 0 && (
                          <div className="mt-3 p-2 bg-light rounded">
                            <small>
                              <strong>{selectedMedicines.length}</strong> medicine(s) selected
                            </small>
                          </div>
                        )}
                      </div>

                      <div className="border-top pt-3">

                        <FormGroup className="mb-3 py-3">
                          <Label><strong>Estimated Time For Delivery:</strong></Label>

                          <div className="d-flex gap-2 flex-wrap">
                            <Input
                              type="select"
                              value={hours}
                              onChange={(e) => setHours(e.target.value)}
                              style={{ width: "150px", height: "35px" }}
                            >
                              <option value="">Select Hrs</option>
                              <option value="0">0 Hrs</option>
                              <option value="1">1 Hrs</option>
                              <option value="2">2 Hrs</option>
                              <option value="3">3 Hrs</option>
                              <option value="4">4 Hrs</option>
                              <option value="5">5 Hrs</option>
                              <option value="6">6 Hrs</option>
                              <option value="7">7 Hrs</option>
                              <option value="8">8 Hrs</option>
                              <option value="9">9 Hrs</option>
                              <option value="10">10 Hrs</option>
                              <option value="11">11 Hrs</option>
                              <option value="12">12 Hrs</option>
                            </Input>

                            <Input
                              type="select"
                              value={minutes}
                              onChange={(e) => setMinutes(e.target.value)}
                              style={{ width: "150px", height: "35px" }}
                            >
                              <option value="">Select Min</option>
                              <option value="5">0 Min</option>
                              <option value="15">15 Min</option>
                              <option value="30">30 Min</option>
                              <option value="45">45 Min</option>
                            </Input>
                          </div>
                        </FormGroup>

                        <FormGroup className="mt-2">
                          <Label><strong>Remark:</strong></Label>
                          <Input
                            type="textarea"
                            placeholder="Enter remark"
                            value={remark}
                            onChange={(e) => setRemark(e.target.value)}
                          />
                        </FormGroup>

                        <p className="mb-1"><strong>Pharmacy:</strong> {selectedRow?.store_name}</p>
                        <p className="mb-0"><strong>Contact:</strong> {selectedRow?.mobile || selectedRow?.contact_number}</p>
                      </div>
                    </ModalBody>

                    <ModalFooter>
                      <Button color="secondary" onClick={() => setViewModal(false)}>
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        onClick={handleConfirmClick}
                        disabled={selectedMedicines.length === 0}
                      >
                        Confirm Assignment ({selectedMedicines.length} items)
                      </Button>
                    </ModalFooter>
                  </Modal>
                </Content>

                {/* Cancel Order Modal */}
                {/* <CancelOrderModal
                  isOpen={showModal}
                  toggle={() => setShowModal(!showModal)}
                  onConfirm={handleCancelOrder}
                  item={selectedRow}
                /> */}
              </>

            }

          </Row>
        </Block>
      </Content >
      <CancelOrderModal
        isOpen={showModal}
        toggle={() => setShowModal(false)}
        onConfirm={handleCancelOrder}
        item={selectedRow}
      />
    </>
  );
};

export default PharmacyDashboard;
